// src/api/axiosInstance.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create an Axios instance with default headers
const createAxiosInstance = () => {
    const instance = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        withCredentials: true
    });

    // Add request interceptor for logging and auth
    instance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('authToken');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error('Request error:', error);
            return Promise.reject(error);
        }
    );

    // Add response interceptor for logging and error handling
    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error('Response error:', error.response.status, error.response.data);
                
                // Handle specific error cases
                if (error.response.status === 401) {
                    // Clear token and redirect to login if unauthorized
                    localStorage.removeItem('authToken');
                    window.location.href = '/login';
                }
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Network error:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error:', error.message);
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

// Create a default instance
const defaultInstance = createAxiosInstance();

// Export the default instance for backward compatibility
export default defaultInstance;

// Export a function to get an instance with the current token
export const getApi = () => {
    return createAxiosInstance();
};
